'use client'

import Script from 'next/script'
import { isBot } from 'utils/isBot/IsBot'

import { URL } from '../../constants/CIAM'
import { useCIAM } from '../../hooks/CIAM/useCIAM/useCIAM'

export function CustomerIdentityAccessManagement() {
	const { enabled, initialize } = useCIAM()

	const init = () => {
		initialize()
	}

	if (!enabled || isBot()) {
		return null
	}

	return <Script src={URL} strategy='afterInteractive' onLoad={init} />
}
